// Create.jsx
import React, { Fragment, useState, useEffect } from "react";
import {
  useGetSingleSupplierQuery,
  usePutSupplierMutation,
} from "../../../features/supplier/supplierApiSlice";
import { useNavigate } from "react-router-dom";
import { notifyError, notifySuccess } from "../../../helpers/Notify";
import { Formik } from "formik";
import * as Yup from "yup";
import "react-tagsinput/react-tagsinput.css";
import { useParams } from "react-router-dom";

const loginSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  TRN: Yup.string().optional("TRN is required"),
  email: Yup.string().email("Invalid email"),
  phone: Yup.string()
    .optional("Phone is required")
    .min(10, "Must be minimum 10 digits")
    .max(15, "Must be less than 15 digits")
    .matches(/^\d+$/, "Phone number must be digits only"),
});

const Edit = () => {
  const navigate = useNavigate();
  const { supplierId } = useParams();
  const user = JSON.parse(localStorage.getItem("user"));
  const { data: supplier, refetch } = useGetSingleSupplierQuery(supplierId);

  const [isView, setIsView] = useState(false);

  useEffect(() => {
    const currentPath = window.location.pathname;
    const containsView = currentPath.includes("/view/");

    if (containsView) {
      setIsView(true);
    }
    refetch();
  }, []);
  const [putSupplier, { isLoading }] = usePutSupplierMutation();
  const handleSubmitted = async (updatedSupplier, supplierId) => {
    try {
      putSupplier({ id: supplierId, updatedSupplier })
        .unwrap()
        .then((response) => {
          notifySuccess("Supplier updated successfully");
          // navigate("supplier");
          navigate("/" + user?.role?.toLowerCase() + "/supplier");
        })
        .catch((error) => {

          notifyError(error.message);
        });
    } catch (error) {
      notifyError(error.message);
    }
  };

  const handleSendData = (updatedSupplier, supplierId) => {
    handleSubmitted(updatedSupplier, supplierId);
    return;
  };

  return (
    <Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">
                  {" "}
                  {isView ? "View Supplier" : "Edit Supplier"}
                </h4>
              </div>
              <div className="card-body">
                <div className="basic-form">
                  <Formik
                    initialValues={{
                      name: supplier?.suppliers?.name || "",
                      email: supplier?.suppliers?.email || "",
                      phone: supplier?.suppliers?.phone || "",
                      TRN: supplier?.suppliers?.TRN || "",
                      detail: supplier?.suppliers?.detail || "",
                      supplierId: supplier?.suppliers?.supplierId || "",
                      address: supplier?.suppliers?.address || "",
                    }}
                    enableReinitialize={true}
                    validationSchema={loginSchema}
                    onSubmit={(values, { setSubmitting }) => {
                      handleSendData(values, supplier?.suppliers?.supplierId);
                      setSubmitting(false);
                    }}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                      setFieldValue,
                    }) => (
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-md-4">
                            <div
                              className={`form-group mb-3 ${
                                values.name
                                  ? errors.name
                                    ? "is-invalid"
                                    : "is-valid"
                                  : ""
                              }`}
                            >
                              <label className="text-label">
                                Supplier Name
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="val-username1"
                                placeholder="Enter name"
                                name="name"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.name}
                                disabled={isView}
                              />
                              <div
                                id="val-username1-error"
                                className="invalid-feedback animated fadeInUp"
                                style={{ display: "block" }}
                              >
                                {errors.name && errors.name}
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div
                              className={`form-group mb-3 ${
                                values.email
                                  ? errors.email
                                    ? "is-invalid"
                                    : "is-valid"
                                  : ""
                              }`}
                            >
                              <label className="text-label">Email</label>
                              <input
                                type="email"
                                className="form-control"
                                id="val-username1"
                                placeholder="Enter Email"
                                name="email"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.email}
                                disabled={isView}
                              />
                              <div
                                id="val-username1-error"
                                className="invalid-feedback animated fadeInUp"
                                style={{ display: "block" }}
                              >
                                {errors.email && errors.email}
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div
                              className={`form-group mb-3 ${
                                values.TRN
                                  ? errors.TRN
                                    ? "is-invalid"
                                    : "is-valid"
                                  : ""
                              }`}
                            >
                              <label className="text-label">TRN No:</label>
                              <input
                                type="number"
                                className="form-control"
                                id="val-username1"
                                placeholder="Enter TRN"
                                name="TRN"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.TRN}
                                disabled={isView}
                              />
                              <div
                                id="val-username1-error"
                                className="invalid-feedback animated fadeInUp"
                                style={{ display: "block" }}
                              >
                                {errors.TRN && errors.TRN}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-4">
                            <div
                              className={`form-group mb-3 ${
                                values.phone
                                  ? errors.phone
                                    ? "is-invalid"
                                    : "is-valid"
                                  : ""
                              }`}
                            >
                              <label className="text-label">Phone No</label>
                              <input
                                type="number"
                                className="form-control"
                                id="val-username1"
                                placeholder="Enter phone no"
                                name="phone"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.phone}
                                disabled={isView}
                              />
                              <div
                                id="val-username1-error"
                                className="invalid-feedback animated fadeInUp"
                                style={{ display: "block" }}
                              >
                                {errors.phone && errors.phone}
                              </div>
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div
                              className={`form-group mb-3 ${
                                values.address
                                  ? errors.address
                                    ? "is-invalid"
                                    : "is-valid"
                                  : ""
                              }`}
                            >
                              <label className="text-label">Address</label>
                              <input
                                type="text"
                                className="form-control"
                                id="val-username1"
                                placeholder="Enter Address"
                                name="address"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.address}
                                disabled={isView}
                              />
                              <div
                                id="val-username1-error"
                                className="invalid-feedback animated fadeInUp"
                                style={{ display: "block" }}
                              >
                                {errors.address && errors.address}
                              </div>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div
                              className={`form-group mb-3 ${
                                values.detail
                                  ? errors.detail
                                    ? "is-invalid"
                                    : "is-valid"
                                  : ""
                              }`}
                            >
                              <label className="text-label">Detail</label>
                              <input
                                type="text"
                                className="form-control"
                                id="val-username1"
                                placeholder="Enter Detail"
                                name="detail"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.detail}
                                disabled={isView}
                              />
                              <div
                                id="val-username1-error"
                                className="invalid-feedback animated fadeInUp"
                                style={{ display: "block" }}
                              >
                                {errors.detail && errors.detail}
                              </div>
                            </div>
                          </div>
                        </div>

                        {!isView && (
                          <div className="text-right">
                            <button
                              type="submit"
                              className="btn btn-primary me-2"
                              disabled={isSubmitting || isLoading}
                            >
                              Update
                            </button>
                          </div>
                        )}
                      </form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Edit;
